export const mapAgeRating = ageRating => {
  return {
    image: ageRating.image.content_url ?? null,
    min_age: ageRating.min_age ?? null,
    name: ageRating.name ?? null,
  };
};
